import { SET_JOBS_VIEW_BY, SET_JOBS_VIEW_BY_ACTIVE } from "../reducers/jobViewByReducer";

export const setJobsViewBy = (jobsViewBy) => ({
  type: SET_JOBS_VIEW_BY,
  data: jobsViewBy
});

export const setJobsViewByActive = (active) => ({
  type: SET_JOBS_VIEW_BY_ACTIVE,
  data: active
});
